export default __webpack_public_path__ + "static/fallback-flow-57fc6d1cb6f949a8a0714865ad5b4ffd.mp4";